module.exports = __webpack_public_path__ + "static/bg-hero-ea129c9991ba1d9332df4000f6c5843a.jpg";